import { render } from "./Footer.vue?vue&type=template&id=7f1ce084&scoped=true"
const script = {}

import "./Footer.vue?vue&type=style&index=0&id=7f1ce084&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f1ce084"]])

export default __exports__